var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.833 10.1979C28.8278 4.125 22.8174 0 16.0278 0C9.18261 0 3.17217 4.125 0.166957 10.1979C0.0556522 10.4271 0 10.7135 0 11C0 11.3438 0.0556522 11.6302 0.166957 11.8594C3.17217 17.9323 9.18261 22 16.0278 22C22.8174 22 28.8278 17.9323 31.833 11.8594C31.9443 11.6302 32 11.3438 32 11.0573C32 10.7135 31.9443 10.4271 31.833 10.1979ZM16.0278 19.25C11.5757 19.25 8.01391 15.5833 8.01391 11C8.01391 6.47396 11.5757 2.75 16.0278 2.75C20.4243 2.75 24.0417 6.47396 24.0417 11V11.0573C24.0417 15.5833 20.4243 19.3073 16.0278 19.3073V19.25ZM16.0278 5.5C15.527 5.55729 15.0261 5.61458 14.5809 5.72917C14.9148 6.1875 15.0817 6.76042 15.0817 7.39062C15.0817 8.88021 13.913 10.0833 12.4661 10.0833C11.8539 10.0833 11.2974 9.91146 10.8522 9.56771C10.7409 10.026 10.6852 10.5417 10.6852 11C10.6852 14.0365 13.0783 16.5 16.0278 16.5C18.9774 16.5 21.3704 14.0365 21.3704 11C21.3704 7.96354 18.9774 5.55729 16.0278 5.55729V5.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ff5176a665c4f3a264961524d2a3b6d0.svg";
export { ForwardRef as ReactComponent };